import React from 'react'
import Phase1 from './Phase1'
import Phase2 from './Phase2'
import Phase3 from './Phase3'

const Services = () => {
  return (
    <div>
      <Phase1/>
      <Phase2/>
      <Phase3/>
    </div>
  )
}

export default Services